export default __webpack_public_path__ + "static/media/pexels-photo-4557402.3136d496.jpeg";